var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 41,
    viewBox: "0 0 26 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1169_3548)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.59961,
    y: 2.25,
    width: 16.35,
    height: 19.05,
    rx: 1,
    stroke: "#0070D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48314 16.2935C8.76208 15.8604 9.01304 15.4039 9.31424 14.9873C9.4916 14.742 9.69772 14.5023 10.0404 14.4993C10.2704 14.4974 10.4043 15.5412 10.4351 15.7216C10.5069 16.1412 10.5619 16.7762 11.0149 17.0319C11.8136 17.483 12.4456 16.2357 12.6049 15.7139C12.6366 15.6103 12.8062 15.1237 12.9923 15.309C13.2458 15.5614 13.3555 16.0511 13.7263 16.045C14.1371 16.0381 14.4602 15.8822 14.7772 15.662C15.0708 15.4581 15.284 15.0985 15.6138 14.9469C15.9764 14.7803 16.5353 15.0316 16.9248 15.1277",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56345 7.94995L17.0381 7.94995",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56345 10.6499L17.0381 10.6499",
    stroke: "#0070D2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.651367 36V28.8906H2.83887C3.46387 28.8906 4.02214 29.0322 4.51367 29.3154C5.00846 29.5954 5.39421 29.9958 5.6709 30.5166C5.94759 31.0342 6.08594 31.6234 6.08594 32.2842V32.6113C6.08594 33.2721 5.94922 33.8597 5.67578 34.374C5.4056 34.8883 5.02311 35.2871 4.52832 35.5703C4.03353 35.8535 3.47526 35.9967 2.85352 36H0.651367ZM2.11621 30.0771V34.8232H2.82422C3.39714 34.8232 3.83496 34.6361 4.1377 34.2617C4.44043 33.8874 4.59505 33.3519 4.60156 32.6553V32.2793C4.60156 31.5566 4.45182 31.0098 4.15234 30.6387C3.85286 30.2643 3.41504 30.0771 2.83887 30.0771H2.11621ZM9.49414 36.0977C8.7194 36.0977 8.08789 35.86 7.59961 35.3848C7.11458 34.9095 6.87207 34.2764 6.87207 33.4854V33.3486C6.87207 32.818 6.97461 32.3444 7.17969 31.9277C7.38477 31.5078 7.67448 31.1855 8.04883 30.9609C8.42643 30.7331 8.85612 30.6191 9.33789 30.6191C10.0605 30.6191 10.6286 30.847 11.042 31.3027C11.4587 31.7585 11.667 32.4046 11.667 33.2412V33.8174H8.30273C8.34831 34.1624 8.48503 34.4391 8.71289 34.6475C8.94401 34.8558 9.23535 34.96 9.58691 34.96C10.1305 34.96 10.5553 34.763 10.8613 34.3691L11.5547 35.1455C11.3431 35.445 11.0566 35.6794 10.6953 35.8486C10.334 36.0146 9.93359 36.0977 9.49414 36.0977ZM9.33301 31.7617C9.05306 31.7617 8.8252 31.8561 8.64941 32.0449C8.47689 32.2337 8.36621 32.5039 8.31738 32.8555H10.2803V32.7432C10.2738 32.4307 10.1891 32.1898 10.0264 32.0205C9.86361 31.848 9.63249 31.7617 9.33301 31.7617ZM14.1621 29.418V30.7168H15.0654V31.752H14.1621V34.3887C14.1621 34.584 14.1995 34.724 14.2744 34.8086C14.3493 34.8932 14.4925 34.9355 14.7041 34.9355C14.8604 34.9355 14.9987 34.9242 15.1191 34.9014V35.9707C14.8424 36.0553 14.5576 36.0977 14.2646 36.0977C13.2751 36.0977 12.7705 35.598 12.751 34.5986V31.752H11.9795V30.7168H12.751V29.418H14.1621ZM18.9131 36C18.848 35.873 18.8008 35.7152 18.7715 35.5264C18.4297 35.9072 17.9854 36.0977 17.4385 36.0977C16.9209 36.0977 16.4912 35.9479 16.1494 35.6484C15.8109 35.349 15.6416 34.9714 15.6416 34.5156C15.6416 33.9557 15.8483 33.526 16.2617 33.2266C16.6784 32.9271 17.279 32.7757 18.0635 32.7725H18.7129V32.4697C18.7129 32.2256 18.6494 32.0303 18.5225 31.8838C18.3988 31.7373 18.2018 31.6641 17.9316 31.6641C17.694 31.6641 17.5068 31.721 17.3701 31.835C17.2367 31.9489 17.1699 32.1051 17.1699 32.3037H15.7588C15.7588 31.9977 15.8532 31.7145 16.042 31.4541C16.2308 31.1937 16.4977 30.9902 16.8428 30.8438C17.1878 30.694 17.5752 30.6191 18.0049 30.6191C18.6559 30.6191 19.1719 30.7835 19.5527 31.1123C19.9368 31.4378 20.1289 31.8968 20.1289 32.4893V34.7793C20.1322 35.2806 20.2021 35.6598 20.3389 35.917V36H18.9131ZM17.7461 35.0186C17.9544 35.0186 18.1465 34.973 18.3223 34.8818C18.498 34.7874 18.6283 34.6621 18.7129 34.5059V33.5977H18.1855C17.4792 33.5977 17.1032 33.8418 17.0576 34.3301L17.0527 34.4131C17.0527 34.5889 17.1146 34.7337 17.2383 34.8477C17.362 34.9616 17.5312 35.0186 17.7461 35.0186ZM22.7021 36H21.2861V30.7168H22.7021V36ZM21.2031 29.3496C21.2031 29.138 21.2731 28.9639 21.4131 28.8271C21.5563 28.6904 21.75 28.6221 21.9941 28.6221C22.235 28.6221 22.4271 28.6904 22.5703 28.8271C22.7135 28.9639 22.7852 29.138 22.7852 29.3496C22.7852 29.5645 22.7119 29.7402 22.5654 29.877C22.4222 30.0137 22.2318 30.082 21.9941 30.082C21.7565 30.082 21.5645 30.0137 21.418 29.877C21.2747 29.7402 21.2031 29.5645 21.2031 29.3496ZM25.3584 36H23.9424V28.5H25.3584V36Z",
    fill: "#0070D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1169_3548",
    x: 0,
    y: 0.75,
    width: 26,
    height: 40.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1169_3548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1169_3548",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.efc3adede2790864d7637f5ecdc28122.svg";
export { ForwardRef as ReactComponent };